export default __webpack_public_path__ + "static/emile-ter-huerne-8408c2c73f6def4774b97ed03d6cb173.jpg";